import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ButtonBase from '@material-ui/core/ButtonBase';
import DeleteIcon from '@material-ui/icons/DeleteForever';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    minHeight: '4rem',
    minWidth: '20rem',
    display: 'flex',
    flexDirection: 'row',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#000',
    borderRadius: 4,
    marginBottom: 4,
  },
  description: {
    flexDirection: 'column',
    display: 'flex',
    padding: '1rem',
    alignItems: 'start'
  },
  image: {
    objectFit: 'none',
    padding: '1rem',
  },
  tick: {
    color: theme.palette.success.main,
    textAlign: 'right',
    alignSelf: 'center',
    flexGrow: 3,
    padding: '1rem',
  },
  delete: {
    marginLeft: '2rem',
    color: theme.palette.action.disabled,
    '&:hover': {
      color: theme.palette.action.active,
    },
  },
}));

const CreditCardCard = ({ card, selected=false, onClick, onDelete }) => {
  const classes = useStyles();
  return (
    <div className={classes.row}>
      <ButtonBase className={classes.container} onClick={onClick}>
        <img className={classes.image} src={card.image_url} alt={card.card_type}/>
        <div className={classes.description}>
          <span>{card.card_type}</span>
          <span>ending in {card.last_4}</span>
          <span>expires {card.expiry_date}</span>
        </div>
        <div className={classes.tick}>
          {selected && <CheckCircleIcon fontSize="large"/>}
        </div>
      </ButtonBase>
      {onDelete && !card.in_use && <DeleteIcon className={classes.delete} onClick={onDelete}/>}
    </div>
  );
};

CreditCardCard.propTypes = {
  card: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CreditCardCard;
